export default [
  {
    path: '/companyinfo',
    name: 'companyInfo',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/companyInfo/CompanyInfo.vue'),
    meta: {},
  },
];
